// NOTE: This file is maintained in the parent project AS Common.
//       Your application should avoid modifying this file.

import { CssBaseline as MuiCssBaseline } from "@mui/material";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { App } from "app/App";
import { BundleIds } from "app/shared/constants";
import { AlertsProvider, Page, useAuth, UsersProvider } from "common";
import { BrowserRouter } from "react-router";
// APP SPECIFIC: Bundle detection, the portal dirty flag provider and the MedActions theme
import { useApp } from "app/appService";
import { DirtyFlagProvider } from "app/portal/DirtyFlagProvider";
import { MedActionsTheme } from "app/theme";

export const AppRoot = () => {
  const auth = useAuth();
  // APP SPECIFIC: The candidate portal bundle authenticates with PortalAuthProvider instead of OIDC
  const { bundleId } = useApp();
  const isTestEnvironment =
    import.meta.env.DEV && import.meta.env.VITE_ENVIRONMENT === "test";

  return (
    <div>
      {(isTestEnvironment ||
        bundleId === BundleIds.MEDONBOARD_PORTAL ||
        auth?.isAuthenticated) && (
        <MuiThemeProvider theme={MedActionsTheme}>
          <MuiCssBaseline />
          <BrowserRouter>
            <AlertsProvider>
              <UsersProvider>
                {/* APP SPECIFIC: DirtyFlagProvider */}
                <DirtyFlagProvider>
                  <Page>
                    <App />
                  </Page>
                </DirtyFlagProvider>
              </UsersProvider>
            </AlertsProvider>
          </BrowserRouter>
        </MuiThemeProvider>
      )}
    </div>
  );
};
